<div *ngIf="status" class="outage-overlay"> 
    <div class="outage-box" [ngClass]="status">
      <div class="status-bar" [ngClass]="status"></div>
  
      <div class="content-area" [ngClass]="status">
        <div class="content-wrapper">
          <div class="text-content">
            <h2 *ngIf="status === 'planned'">Scheduled Maintenance</h2>
            <p *ngIf="status === 'planned'">Friday March 28th, 8:30 a.m.</p>
            <small class="subtext" *ngIf="status === 'planned'">We'll be performing scheduled maintenance.</small>
  
            <h2 *ngIf="status === 'in-progress'">Application Server Down</h2>
            <p *ngIf="status === 'in-progress'">An unexpected error occured.</p>
            <small class="subtext" *ngIf="status === 'in-progress'">Our team is actively working. Thank you for your patience.</small>
          </div>
        </div>
      </div>
  
      <div class="footer">
        <button class="dismiss-button" (click)="dismiss()">Okay, Got it</button>
      </div>
    </div>
  </div>
  